import {Directive, ElementRef, OnDestroy, output} from '@angular/core';

@Directive({
  selector: '[appElementVisible]'
})
export class ElementVisibleDirective implements OnDestroy {
  visibleChanged = output<boolean>();

  private readonly observer: IntersectionObserver;

  constructor(private readonly el: ElementRef) {
    this.observer = new IntersectionObserver((event: IntersectionObserverEntry[]) => {
      this.visibleChanged.emit(!!event.find(entry => entry.target === el.nativeElement && entry.isIntersecting));
    })
    this.observer.observe(el.nativeElement)
  }

  ngOnDestroy() {
    this.observer.unobserve(this.el.nativeElement);
  }

}
